export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'extras': { id: 'extras', page: 'toutHorizontal', getter: () => import(/* webpackChunkName: 'extras' */ 'components/bolt/toutHorizontal/toutHorizontal') },
	'boltPhotobooth': { id: 'boltPhotobooth', page: 'photobooth', getter: () => import(/* webpackChunkName: 'boltPhotobooth' */ 'components/bolt/photobooth/photobooth') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'extras', getter: () => import(/* webpackChunkName: "extras" */ 'components/bolt/toutHorizontal/toutHorizontal'), component: 'toutHorizontal' },
	{ id: 'signUp', getter: () => import(/* webpackChunkName: "signUp" */ 'components/bolt/text/text'), component: 'text' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
